// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box, Button } from 'grommet'
import React from 'react'
import PropTypes from 'prop-types'
import { FormDown, FormUp } from 'grommet-icons'

import { Typography } from '../../../../components'

const MenuButton = ({ label, open, ...rest }) => {
  const Icon = open ? FormUp : FormDown
  return (
    <Button hoverIndicator="background" {...rest}>
      <Box direction="row" align="center" pad="xsmall" justify="between">
        <Typography size="small" type="text" color="text-week">
          {label}
        </Typography>
        <Icon />
      </Box>
    </Button>
  )
}
MenuButton.propTypes = {
  label: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired
}

export { MenuButton }
